import React from "react";
import Select from "components/shared/Select";
import selectors from "constants/poetry/poems/show/selectors";
import helpers from "helpers/base";

class ComponentItemSelect extends React.Component {
  selectComponentItem(item) {
    const { title } = item;
    const { modalTitle } = item;
    const modalCategory = modalTitle + (title ? ": " : "") + title;
    const { category } = item;
    const { componentValue } = item;
    const { componentContent } = item;
    const { activeContext } = item;

    const selector = `${selectors.COMPONENT}[data-category='${category}']`;
    const $component = $(selector);
    const $section = $component.closest(selectors.SECTION);

    if (helpers.isMobile() || $section.hasClass("is-focused")) {
      const $title = $($component.find(selectors.COMPONENT_TITLE));
      const $valueReplace = $(
        $component.find(selectors.COMPONENT_VALUE_REPLACE)
      );
      const $activeContext = $($component.find(selectors.ACTIVE_CONTEXT_NOTE));
      const $poemContent = $(selectors.POEM_CONTENT);
      const $modalCategory = $(selectors.TEXT_MODAL_CATEGORY);

      $title.text(title);

      if (componentContent) {
        $poemContent.html(componentContent);
        $component.data("content", componentContent);
      }

      $modalCategory.text(modalCategory);
      $activeContext.html(activeContext);
      $valueReplace.html(componentValue);
    }
  }

  onChange(option) {
    this.selectComponentItem(option);
  }

  render() {
    return (
      <Select
        {...this.props}
        id="poem-component-items__select"
        placeholder="Select vocabulary word"
        onChange={(value) => this.onChange(value)}
      />
    );
  }
}

export default ComponentItemSelect;
